module.exports = __webpack_public_path__ + "static/media/IS_Brand_color.d450542d.png";